<template>
<div id="learnitbox-root">

<div v-for="(line, index) in lines" :key="index">


<div v-show="isVisible(index)" 
class="learn-it bg-gray-200 px-4 py-3 shadow-md">

<div class="h-10">
<div class="float-right mr-2 my-2 text-sm font-bold text-gray-500"><span v-html="index+1"></span> of {{ lines.length }}</div>
</div>

  <div class="w-full flex flex-wrap mb-4">
  <div class="w-full sm:w-1/5 text-gray-700 font-bold">Translate: </div>
  <div class="w-full sm:w-4/5" v-html="line.sentence_foreign">sentence foreign</div>
  </div>

  <div class="w-full flex flex-wrap mb-4">
  <div class="w-full sm:w-1/5 tracking-wide text-gray-700 font-bold mb-1 mt-auto mb-auto" >
        Your Answer:
  </div>

  <div class="flex flex-wrap inline-flex w-full sm:w-4/5">

   <div class="flex-grow mr-2">
   <input class="w-full form-input outline-none border-2 py-2 border-gray-400 focus:border-blue-400 focus:shadow-none focus:bg-white mb-2 md:mb-0 rounded-md" placeholder="Enter English Translation"></input>
   </div>
  
   <div class="flex-none w-full sm:w-auto" >
   <button @click="showId=index" class="max-w-full bg-blue-700 shadow hover:bg-blue-500 focus:outline-none text-white font-bold px-4 rounded-md" type="button" style="padding-top:0.6em;padding-bottom:0.6em">
   Show Answer  </button>
   </div>


   </div>
     
     </div>


<div v-show="showAnswer(index)">
<p class="w-full sm:w-1/5 tracking-wide text-gray-700 font-bold mb-1 mt-auto mb-auto">Correct Answer:</p>
  
<blockquote class="border-l-4 border-orange-600 italic my-4 pl-4 md:pl-8" v-html="line.sentence_english">sentence english</blockquote>
</div>

<!--  
<p>How did you do?</p>
<div class="inline-flex">
<svg class="h-6 w-6 mr-2 flex-shrink-0" viewBox="0 0 24 24"><circle class="text-green-200 fill-current" cx="12" cy="12" r="10"></circle><path class="text-green-600 fill-current" d="M10 14.59l6.3-6.3a1 1 0 0 1 1.4 1.42l-7 7a1 1 0 0 1-1.4 0l-3-3a1 1 0 0 1 1.4-1.42l2.3 2.3z"></path></svg>
Got it! 
<svg class="h-6 w-6 mr-2 flex-shrink-0" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#fed7d7"></circle><path fill="#f56565" d="M13.41 12l2.83 2.83a1 1 0 0 1-1.41 1.41L12 13.41l-2.83 2.83a1 1 0 1 1-1.41-1.41L10.59 12 7.76 9.17a1 1 0 0 1 1.41-1.41L12 10.59l2.83-2.83a1 1 0 0 1 1.41 1.41L13.41 12z"></path></svg>
Try Again
</dov>
</div>

-->

<div class="h-10">
  <div class="float-right">  
  <button @click="visibleId=index+1" v-html="showAnswer(index) ? 'Next »' : 'Skip' " v-bind:class="{ 'bg-gray-700': showAnswer(index) }" class="shadow bg-gray-400 hover:bg-gray-800 focus:outline-none focus:bg-gray-700 text-white font-bold py-2 px-4 rounded mr-0"  type="button">
Skip  </button>
  </div>
</div>

</div>


</div><!-- End For -->

<div v-show="isVisible(lines.length)" class="learn-it bg-gray-200 px-4 py-3 shadow-md container mx-auto px-12 text-center">
    <p class="text-3xl font-bold">Congratulations!<p>
        <p class="text-2xl">All done!</p>
<div class="h-10 mt-10">

  <button @click="visibleId=0" class="shadow bg-gray-600 hover:bg-gray-800 focus:outline-none focus:bg-gray-700 text-white font-bold py-2 px-4 rounded mr-0"  type="button">
Restart  </button>

</div>
</div>

</div><!-- Component Root -->
</template>

<script>
  /* VisibleId = id of the panel to set to visible*/
  /* ShowId = id of the panel for which to show answer () */
export default {
    props: ['lines'],
    data(){

        return {
            visibleId: 0,
            showId: null,
        }
    },
    methods: {
        isVisible(index) { return this.visibleId === index },
        showAnswer(index) { return this.showId === index },
    }
}
</script>

<style>
.fade-enter{
    opacity: 0;
    height: 0;
}
.fade-enter-active{
    transition: opacity 0.5s ease-out;
    
}
.fade-enter-to{
    opacity: 1;
    height: auto;
    
}
</style>